// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__3VDHk","marketplaceStroke":"IconEmailAttention_marketplaceStroke__2iT0E","attentionStroke":"IconEmailAttention_attentionStroke__3gwoD"};